// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1SVW2","upload":"Small_upload__2PjRW","imageWrap":"Small_imageWrap__2bSuq","removeBtn":"Small_removeBtn__1IV3O"};